"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  'template-a[desktop]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 100,
      'letterSpacing': 0,
      'lineHeightPx': 100,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -416,
        'y': -1072,
        'width': 900,
        'height': 100
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 40,
      'letterSpacing': 0,
      'lineHeightPx': 48,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -416,
        'y': -984,
        'width': 900,
        'height': 48
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 142,
        'y': -891,
        'width': 435,
        'height': 199
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line4': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 72,
      'letterSpacing': 0,
      'lineHeightPx': 72,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -509,
        'y': 158,
        'width': 405,
        'height': 72
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line5': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 24,
      'letterSpacing': 0,
      'lineHeightPx': 36,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': -509,
        'y': 218,
        'width': 405,
        'height': 108
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-a[tablet]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 934,
        'y': -1072,
        'width': 708,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 934,
        'y': -994,
        'width': 708,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1081.5,
        'y': -901,
        'width': 421,
        'height': 93
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  },
  'template-a[mobile]': {
    'line1': {
      'fontFamily': 'Absolute Beauty Script',
      'fontWeight': 400,
      'fontSize': 90,
      'letterSpacing': 0,
      'lineHeightPx': 90,
      'color': {
        'r': 0.4117647111415863,
        'g': 0.10980392247438431,
        'b': 0.2078431397676468,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1846,
        'y': -1102,
        'width': 327,
        'height': 90
      },
      'children': [],
      'backgrondColor': '#290a14'
    },
    'line2': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 700,
      'fontSize': 32,
      'letterSpacing': 0,
      'lineHeightPx': 40,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1846,
        'y': -1024,
        'width': 327,
        'height': 40
      },
      'children': [],
      'backgrondColor': '#070c0d'
    },
    'line3': {
      'fontFamily': 'Objektiv Mk2',
      'fontWeight': 300,
      'fontSize': 16,
      'letterSpacing': 0,
      'lineHeightPx': 24,
      'color': {
        'r': 0.07450980693101883,
        'g': 0.12941177189350128,
        'b': 0.13333334028720856,
        'a': 1
      },
      'absoluteBoundingBox': {
        'x': 1846,
        'y': -945.5,
        'width': 327,
        'height': 120
      },
      'children': [],
      'backgrondColor': '#070c0d'
    }
  }
};
exports.default = _default;